import { getSearchParams } from '@wix/package-picker-shared';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
const getBiEventLink = _ref => {
  let {
    src,
    evid
  } = _ref;
  return `https://bo.wix.com/data-tools/bi-catalog-app/event/${src}%3A${evid}`;
};
export const useBiLogger = () => {
  const premiumEssentialsContext = usePremiumEssentialsContext();
  const {
    biLogger
  } = premiumEssentialsContext;
  const {
    debug
  } = getSearchParams();
  if (!debug || !biLogger) {
    return {
      biLogger
    };
  }
  return {
    biLogger: {
      ...biLogger,
      report: event => {
        const link = getBiEventLink({
          src: event.src,
          evid: event.evid
        });
        console.log('BI Logger Report:', event, link);
        return biLogger.report(event);
      }
    }
  };
};
//# sourceMappingURL=useBiLogger.js.map